<template>
  <button
    ref="Sync"
    v-tooltip="tooltip"
    class="SyncButton"
    :class="{
      'is-disabled': disabled,
      'is-sync': localSyncing && !disabled,
      'is-highlight': highlight && !disabled
    }"
    @click="onClick"
  >
    <lm-icon :icon="resolveIcon" />
  </button>
</template>

<script>
import LmIcon from '@/components/ui/LmIcon'
export default {
  name: 'SyncButton',
  components: {LmIcon},
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    highlight: {
      type: Boolean,
      default: false
    },
    syncing: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      localSyncing: false
    }
  },
  computed: {
    resolveIcon() {
      return this.disabled ? 'syncDisabled' : 'sync'
    }
  },
  watch: {
    syncing(v) {
      if (v) {
        this.localSyncing = true
      } else {
        let that = this
        this.$refs.Sync.addEventListener('animationiteration', function cb(e) {
          that.localSyncing = false
          e.currentTarget.removeEventListener(e.type, cb)
        })
      }
    }
  },
  methods: {
    onClick(event) {
      if (!this.disabled) {
        this.$emit('click', event)
      }
    }
  }
}
</script>

<style>
.js-focus-visible .SyncButton:focus:not(.focus-visible) {
  outline: none;
}
</style>
<style scoped>
.SyncButton {
  &:hover {
    svg {
      color: theme('colors.gray.900');
    }
  }
  &.is-disabled {
    cursor: default;
    svg {
      color: theme('colors.gray.500');
    }
  }
  &.is-sync {
    animation: rotate-back 1s infinite linear;
  }
  &.is-highlight {
    animation: blink 0.5s 4;
    svg {
      color: theme('colors.highlight');
    }
  }
}
</style>
